export default __webpack_public_path__ + "static/media/logo_white.05d6dd57.svg";